// extracted by mini-css-extract-plugin
export default {"container":"SpecialNoticeList_container__oZrAy","cardContainer":"SpecialNoticeList_cardContainer__FdaI3"};